import { render, staticRenderFns } from "./viewFeedback.vue?vue&type=template&id=78544740&scoped=true&"
import script from "./viewFeedback.vue?vue&type=script&lang=js&"
export * from "./viewFeedback.vue?vue&type=script&lang=js&"
import style0 from "./viewFeedback.vue?vue&type=style&index=0&id=78544740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78544740",
  null
  
)

export default component.exports